"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
require("firebase/firestore");
var util_1 = require("../util");
var domain_1 = require("../types/domain");
var actions = function (router, appConfig) { return ({
    // return the devradar ID for a given alias (also returns ID if input is already a valid ID)
    followRadarAlias: function (_a, alias) {
        var commit = _a.commit;
        if (alias === void 0) { alias = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var response, radarSnapshot, e_1, aliasSnapshot, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        response = '';
                        radarSnapshot = {};
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 8]);
                        return [4 /*yield*/, app_1.default.firestore().collection('radars').doc(alias).get()];
                    case 2:
                        radarSnapshot = _b.sent();
                        return [3 /*break*/, 8];
                    case 3:
                        e_1 = _b.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!radarSnapshot.exists) return [3 /*break*/, 5];
                        response = radarSnapshot.id;
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, app_1.default.firestore().collection('radarAliases')
                            .where('alias', '==', alias)
                            .limit(1)
                            .get()];
                    case 6:
                        aliasSnapshot = _b.sent();
                        if (aliasSnapshot.size === 0) {
                            console.error('No devradar found for this alias (or ID):', alias); // eslint-disable-line no-console
                            response = '';
                        }
                        else {
                            data = aliasSnapshot.docs[0].data();
                            response = data.radarId;
                            commit('setRadarAlias', alias);
                        }
                        _b.label = 7;
                    case 7: return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, response];
                }
            });
        });
    },
    // check if a given radarId already has an alias
    findAliasForRadarId: function (_a, id) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var aliasSnapshot, data, alias;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, app_1.default.firestore().collection('radarAliases')
                            .where('radarId', '==', id)
                            .limit(1)
                            .get()];
                    case 1:
                        aliasSnapshot = _b.sent();
                        if (aliasSnapshot.size === 0) {
                            return [2 /*return*/, ''];
                        }
                        else {
                            data = aliasSnapshot.docs[0].data();
                            alias = data.alias;
                            commit('setRadarAlias', alias);
                            return [2 /*return*/, alias];
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    getRadar: function (_a, id) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var radarSnapshot, _b, categories, levels, title, _c, isPublic, owner, blipSnapshot, e_2;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit('setLoading', true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, app_1.default.firestore().collection('radars').doc(id).get()];
                    case 2:
                        radarSnapshot = _d.sent();
                        _b = radarSnapshot.data(), categories = _b.categories, levels = _b.levels, title = _b.title, _c = _b.isPublic, isPublic = _c === void 0 ? false : _c, owner = _b.owner;
                        commit('setMeta', { title: title || "devradar #" + id, categories: categories, levels: levels });
                        commit('setIsPublic', isPublic);
                        commit('setId', id);
                        commit('setOwnerId', owner);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + radarSnapshot.id + "/blips")
                                .limit(100)
                                .get()];
                    case 3:
                        blipSnapshot = _d.sent();
                        commit('dropBlips');
                        blipSnapshot.forEach(function (doc) { return __awaiter(_this, void 0, void 0, function () {
                            var blip;
                            return __generator(this, function (_a) {
                                blip = util_1.cleanBlip(doc.data());
                                blip.id = doc.id; // ensure that firebase._id is used
                                commit('addBlip', blip);
                                return [2 /*return*/];
                            });
                        }); });
                        return [4 /*yield*/, dispatch('findAliasForRadarId', id)];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _d.sent();
                        console.error('Error while fetching radar: ', id); // eslint-disable-line no-console
                        console.error(e_2); // eslint-disable-line no-console
                        return [3 /*break*/, 6];
                    case 6:
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    // call getRadar if the id is different from the one currently in state
    getRadarLazy: function (_a, aliasOrId) {
        var dispatch = _a.dispatch, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var loadedId, targetId, radarId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        loadedId = rootGetters['blips/radarId'];
                        targetId = aliasOrId;
                        if (!(aliasOrId.toLocaleLowerCase() === 'me')) return [3 /*break*/, 1];
                        if (rootGetters['user/loginState'] === domain_1.LoginState.LOGGED_OUT) {
                            console.warn('Could not resolve radarId', targetId); // eslint-disable-line no-console
                            router.push({ name: 'error', params: { errorCode: '404' } });
                        }
                        else {
                            targetId = rootGetters['user/radarId'];
                            if (!targetId) {
                                console.warn('Could not resolve radarId', targetId); // eslint-disable-line no-console
                                router.push({ name: 'error', params: { errorCode: '404' } });
                            }
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, dispatch('followRadarAlias', targetId)];
                    case 2:
                        radarId = _b.sent();
                        if (loadedId !== radarId && radarId !== '') {
                            return [2 /*return*/, dispatch('getRadar', radarId)];
                        }
                        else if (radarId === '') {
                            console.warn('entry does not exist for radarId', radarId); // eslint-disable-line no-console
                            router.push({ name: 'error', params: { errorCode: '404' } });
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    },
    addBlip: function (_a, blip) {
        var commit = _a.commit, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var radarId, nBlip, changes, setSnapshot;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setLoading', true);
                        radarId = getters['radarId'];
                        nBlip = util_1.cleanBlip(blip);
                        changes = blip.changes;
                        // assign IDs to changes
                        nBlip.changes = changes
                            .map(function (c) {
                            if (!c.id)
                                c.id = util_1.getUUID();
                            return c;
                        })
                            .map(util_1.cleanChange);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + radarId + "/blips").add(JSON.parse(JSON.stringify(nBlip)))]; // JSON parsing to prevent this error from occuring: https://stackoverflow.com/questions/48156234/function-documentreference-set-called-with-invalid-data-unsupported-field-val
                    case 1:
                        setSnapshot = _b.sent() // JSON parsing to prevent this error from occuring: https://stackoverflow.com/questions/48156234/function-documentreference-set-called-with-invalid-data-unsupported-field-val
                        ;
                        nBlip['id'] = setSnapshot.id;
                        commit('addBlip', nBlip);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    updateBlip: function (_a, blip) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var user, nBlip;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        nBlip = util_1.cleanBlip(blip);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + user.radar + "/blips").doc(blip.id).update(nBlip)];
                    case 1:
                        _b.sent();
                        commit('exchangeBlip', blip);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteBlip: function (_a, blip) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + user.radar + "/blips").doc(blip.id).delete()];
                    case 1:
                        _b.sent();
                        commit('removeBlip', blip);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    setBlips: function (_a, blips) {
        var commit = _a.commit, rootGetters = _a.rootGetters, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var user, collectionSnapshot;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + user.radar + "/blips").limit(100).get()];
                    case 1:
                        collectionSnapshot = _b.sent();
                        return [4 /*yield*/, Promise.all(collectionSnapshot.docs.map(function (docSnapshot) {
                                return app_1.default.firestore().collection("radars/" + user.radar + "/blips").doc(docSnapshot.id).delete();
                            }))];
                    case 2:
                        _b.sent();
                        commit('dropBlips');
                        // add all new blips
                        return [4 /*yield*/, Promise.all(blips.map(util_1.cleanBlip).map(function (b) { return dispatch('addBlip', b); }))];
                    case 3:
                        // add all new blips
                        _b.sent();
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    addChange: function (_a, _b) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        var blip = _b.blip, change = _b.change;
        return __awaiter(this, void 0, void 0, function () {
            var user, newChange, nBlip;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        if (!blip['changes'])
                            blip.changes = [];
                        newChange = util_1.cleanChange(change);
                        newChange.id = util_1.getUUID();
                        blip.changes.push(newChange);
                        nBlip = util_1.cleanBlip(blip);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + user.radar + "/blips").doc(blip.id).update(nBlip)];
                    case 1:
                        _c.sent();
                        commit('exchangeBlip', blip);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteChange: function (_a, _b) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        var blip = _b.blip, change = _b.change;
        return __awaiter(this, void 0, void 0, function () {
            var user, nBlip;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        blip.changes = blip.changes.filter(function (c) { return c.id !== change.id; });
                        nBlip = util_1.cleanBlip(blip);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + user.radar + "/blips").doc(blip.id).update(nBlip)];
                    case 1:
                        _c.sent();
                        commit('exchangeBlip', blip);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    setMeta: function (_a, meta) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setLoading', true);
                        user = rootGetters['user/user'];
                        return [4 /*yield*/, app_1.default.firestore().collection("radars").doc(user.radar).update(meta)];
                    case 1:
                        _b.sent();
                        commit('setMeta', meta);
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getRadarAlias: function (_a) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var user, aliasSnapshot, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        user = rootGetters['user/user'];
                        if (!user || !user.radar)
                            return [2 /*return*/];
                        return [4 /*yield*/, app_1.default.firestore().collection('radarAliases').doc(user.uid).get()];
                    case 1:
                        aliasSnapshot = _b.sent();
                        if (aliasSnapshot.exists) {
                            data = aliasSnapshot.data();
                            commit('setRadarAlias', data.alias);
                        }
                        else {
                            commit('setRadarAlias', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    setRadarAlias: function (_a, _b) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        var alias = _b.alias, radarId = _b.radarId;
        return __awaiter(this, void 0, void 0, function () {
            var user, doc;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        user = rootGetters['user/user'];
                        if (!user || !user.radar)
                            return [2 /*return*/];
                        doc = {
                            alias: alias,
                            radarId: radarId
                        };
                        return [4 /*yield*/, app_1.default.firestore().collection('radarAliases').doc(user.uid).set(doc)];
                    case 1:
                        _c.sent();
                        commit('setRadarAlias', alias);
                        router.push({ name: 'radar', params: { radarId: alias } });
                        return [2 /*return*/];
                }
            });
        });
    },
    isRadarAliasAvailable: function (_context, alias) {
        return __awaiter(this, void 0, void 0, function () {
            var aliasSnapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, app_1.default.firestore().collection('radarAliases')
                            .where('alias', '==', alias)
                            .limit(1)
                            .get()];
                    case 1:
                        aliasSnapshot = _a.sent();
                        return [2 /*return*/, aliasSnapshot.size === 0];
                }
            });
        });
    }
}); };
exports.default = actions;
